import React, { useCallback, useEffect, useState } from 'react';
import { css } from 'styled-components';

//components
import Layout from 'src/components/common/theme/Layout';
import { UitkMenu, UitkMenuTrigger, UitkMenuContainer, PositionType, UitkMenuList } from 'uitk-react-menu';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLink } from 'uitk-react-link';

//helpers
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
import { getStore } from 'src/utils/store-utils';
import { getMenuItems, useSimpleMenuDataHook } from './helpers';
import { checkValue } from 'src/components/functions';

//types
import { simpleMenuProps } from './types';

import(
  /* webpackChunkName: "simple-menu-styles" */ 'src/components/common/modules/global-header/simple-menu/styles/simple-menu.css'
);

const SiimpleMenu: React.FC<simpleMenuProps> = (props) => {
  const storeData = getStore();

  const {
    partnerHeaderNavigation,
    subHeaderHamburgerMenuBackgroundColor,
    subHeaderHamburgerMenuBackgroundHoverColor,
    subHeaderHamburgerMenuIconColor,
    subHeaderHamburgerMenuTextColor,
    subHeaderHamburgerMenuTextHoverColor,
    subHeaderHamburgerMenuBackgroundSelectedColor,
  } = storeData;

  //use hooks to get data
  const { subHeaderMenuText } = useSimpleMenuDataHook(storeData, props?.menuProps);

  const { width: windowWidth } = useWindowDimensions();

  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isMobileMenu, setIsMobileMenu] = useState(windowWidth <= 575);

  useEffect(() => {
    setIsMobileMenu(windowWidth <= 575);
  }, [windowWidth]);

  const handleMenuClick = useCallback(() => {
    setIsShowMenu((prev) => !prev);
  }, []);

  //close the menu when device width changes
  useEffect(() => {
    setIsShowMenu(false);
  }, [isMobileMenu]);

  const MENU_ITEMS = checkValue(props?.menuProps?.menuItems)
    ? props?.menuProps?.menuItems
    : getMenuItems(partnerHeaderNavigation, isMobileMenu);

  const moduleCss = () => {
    const iconColor = checkValue(subHeaderHamburgerMenuIconColor) ? subHeaderHamburgerMenuIconColor : '#141d38';
    const menuBckColor = checkValue(subHeaderHamburgerMenuBackgroundColor)
      ? subHeaderHamburgerMenuBackgroundColor
      : '#ffffff';
    const menuTxtColor = checkValue(subHeaderHamburgerMenuTextColor) ? subHeaderHamburgerMenuTextColor : '#191e3b';
    const menuBckHoverColor = checkValue(subHeaderHamburgerMenuBackgroundHoverColor)
      ? subHeaderHamburgerMenuBackgroundHoverColor
      : '#191e3b';
    const menuTxtHoverColor = checkValue(subHeaderHamburgerMenuTextHoverColor)
      ? subHeaderHamburgerMenuTextHoverColor
      : '#ffffff';
    const menuBckSelectedColor = checkValue(subHeaderHamburgerMenuBackgroundSelectedColor)
      ? subHeaderHamburgerMenuBackgroundSelectedColor
      : checkValue(subHeaderHamburgerMenuBackgroundHoverColor)
      ? subHeaderHamburgerMenuBackgroundHoverColor
      : '#191e3b';

    return `
    &.partner-header-simple-menu {
      visibility: ${props?.loadMenus ? 'visible' : 'hidden'};}
      .sub-header-simple-menu-trigger{color:${iconColor} !important;}
      .sub-header-simple-menu-items-container{background-color:${menuBckColor} !important;}
      .partner-header-simple-menu-item {
        color:${menuTxtColor} !important;
        &:hover {
          color:${menuTxtHoverColor} !important;
          background-color:${menuBckHoverColor} !important;
        }
        &.selected {
          color:${menuTxtHoverColor} !important;
          background-color:${menuBckSelectedColor} !important;
        }
      }
      .sub-header-simple-menu .sub-header-simple-menu-trigger:hover:before,
      .sub-header-simple-menu.menu-open .sub-header-simple-menu-trigger:before {
        background-color:${menuTxtColor} !important;
      }
    }
    `;
  };

  if (!checkValue(MENU_ITEMS, true)) {
    return null;
  }

  return (
    <Layout
      HtmlTag="div"
      className="partner-header-simple-menu"
      css={css`
        ${moduleCss()}
      `}
    >
      <UitkMenu
        id="simpleMenu"
        isOpen={isShowMenu}
        onTriggerClick={() => handleMenuClick()}
        className={`sub-header-simple-menu ${isShowMenu ? 'menu-open' : ''}`}
        key={isMobileMenu.toString()}
      >
        <UitkMenuTrigger>
          <UitkLink className="sub-header-simple-menu-trigger">
            {isMobileMenu ? (
              <button>
                <UitkIcon
                  name="menu"
                  className="sub-header-simple-menu-trigger-icon-mobile"
                  size={UitkIconSize.MEDIUM}
                />
              </button>
            ) : (
              <button>
                {subHeaderMenuText}
                <UitkIcon name="expand_more" className="sub-header-simple-menu-trigger-icon" />
              </button>
            )}
          </UitkLink>
        </UitkMenuTrigger>
        <UitkMenuContainer
          className="sub-header-simple-menu-items-container"
          position={PositionType.LEFT}
          autoPosition={checkValue(props?.menuProps?.autoPosition) ? props?.menuProps?.autoPosition : false}
        >
          <UitkMenuList items={MENU_ITEMS} />
        </UitkMenuContainer>
      </UitkMenu>
    </Layout>
  );
};

export default SiimpleMenu;
